// extracted by mini-css-extract-plugin
export default {"contenido":"cookies_contenido__adg5e"};